import { Button, Col, Form, Input, Row, Select, Space, Table } from 'antd';
import React, { useState, useContext } from 'react';
import './salesQuotation.css'
import { ConstContext } from '../../store/context/constContext'
import ItemMasterData from '../../components/masterData/itemMasterData'
const { Option } = Select;
const { Search } = Input;

const SalesQuotation = () => {
  const [expand, setExpand] = useState(false);
  const [form] = Form.useForm();
  // Contexts
  const {
    showItemMasterData,
    setShowItemMasterData
  } = useContext(ConstContext)

  const columns = [
    {
      title: 'Mã hàng',
      width: 100,
      dataIndex: 'ItemCode',
      key: 'ItemCode',
      fixed: 'left',
    },
    {
      title: 'Tên hàng',
      width: 100,
      dataIndex: 'ItemName',
      key: 'ItemName',
      fixed: 'left',
    },
    {
      title: 'ĐVT',
      dataIndex: 'UoMName',
      key: 'UoMName',
      width: 150,
    },
    {
      title: 'Định lượng',
      dataIndex: '',
      key: '2',
      width: 150,
    },
    {
      title: 'Chiều dài',
      dataIndex: '',
      key: '3',
      width: 150,
    },
    {
      title: 'Số ream/cuộn',
      dataIndex: '',
      key: '4',
      width: 150,
    },
    {
      title: 'Số lượng',
      dataIndex: '',
      key: '5',
      width: 150,
    },
    {
      title: 'Giá sau VAT',
      dataIndex: '',
      key: '6',
      width: 150,
    },
    {
      title: 'Giá chưa hoa hồng',
      dataIndex: 'address',
      key: '7',
      width: 150,
    },
    {
      title: 'Tổng tiền',
      dataIndex: '',
      key: '8',
      width: 150,
    },
    {
      title: 'Nhóm thuế',
      dataIndex: '',
      key: '9',
      width: 150
    },
    {
      title: 'Action',
      key: 'operation',
      fixed: 'right',
      width: 100,
      render: () => <a>delete</a>,
    },
  ];
  const data = [];
  for (let i = 0; i < 100; i++) {
    data.push({
      key: i,
      name: `Item No ${i}`,
      age: 32,
      address: `London Park no. ${i}`,
    });
  }
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 7 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };
  const onFinish = (values) => {
    console.log('Received values of form: ', values);
  };
  const onSearch = (value) => console.log(value);

  return (
    <>
      <Form {...formItemLayout} form={form} style={{ padding: '16px 32px' }} name="advanced_search" layout="horizontal" className="ant-advanced-search-form" size={'small'} onFinish={onFinish} >
        {/* column1 */}
        <Row >
          <Col span={24} >
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
              <Form.Item name={`CardCode`} label={`Mã khách hàng`} style={{ width: '50%' }}
                rules={[
                  {
                    required: true,
                    message: 'Hãy nhập mã khách hàng!',
                  },
                ]}>
                <Search onSearch={onSearch} />
              </Form.Item>

              <Form.Item name={`ShipAddr`} label={`Địa chỉ giao hàng`} style={{ width: '50%' }}
                rules={[
                  {
                    required: true,
                    message: 'Hãy nhập địa chỉ giao hàng!',
                  },
                ]}>
                <Input.TextArea showCount maxLength={250} />
              </Form.Item>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
              <Form.Item name={`LoaiThanhToan`} label={`Loại thanh toán`} style={{ width: '50%' }}
                rules={[
                  {
                    required: true,
                    message: 'Hãy chọn oại thanh toán!',
                  },
                ]}>
                <Select placeholder="Chọn hình thức thanh toán">
                  <Option value="male">Tiền mặt</Option>
                  <Option value="female">Công nợ 15 ngày</Option>
                  <Option value="other">Công nợ 45 ngày</Option>
                </Select>
              </Form.Item>
              <Form.Item name={`CardName`} label={`Tên Khách hàng`} style={{ width: '50%' }}
                rules={[
                  {
                    required: true,
                    message: 'Input something!',
                  },
                ]} >
                <Search onSearch={onSearch} />
              </Form.Item>
            </div>
          </Col>


        </Row>
        <Row>
          <Col span={24}>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
              <Form.Item name={`BillAddr`} label={`Địa chỉ hóa đơn`} style={{ width: '50%' }}
                rules={[
                  {
                    required: true,
                    message: 'Input something!',
                  },
                ]}>
                <Input.TextArea showCount maxLength={250} />
              </Form.Item>
              <Form.Item name={`Whs`} label={`Kho`} style={{ width: '50%' }}
                rules={[
                  {
                    required: true,
                    message: 'Input something!',
                  },
                ]}>
                <Select placeholder="Chọn kho">
                  <Option value="male">Kho tổng Long An</Option>
                  <Option value="female">Kho Long An</Option>
                  <Option value="other">Kho Củ Chi</Option>
                </Select>
              </Form.Item>
            </div>

          </Col>

        </Row>
        <Row width={"100%"} style={{marginBottom: '16px'}}>
          <Col span={24}>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
              <Form.Item name={`BPPhone`} label={`Số điện thoại`} style={{ width: '50%' }}
                rules={[
                  {
                    required: true,
                    message: 'Input something!',
                  },
                ]}>
                <Search onSearch={onSearch} />
              </Form.Item>
              <Form.Item name={`BPPerson`} label={`Người liên hệ`} style={{ width: '50%' }}>
                <Select placeholder="Chọn người liên hệ">
                  <Option value="male">Male</Option>
                  <Option value="female">Female</Option>
                  <Option value="other">Other</Option>
                </Select>
              </Form.Item>
            </div>
          </Col>
        </Row>

        <Table columns={columns} dataSource={data} scroll={{ x: 1500, y: 300 }} />
        <Row>
          <Col span={24} style={{ textAlign: 'left' }}>
            <div style={{width: '100%', display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <Button type="primary" htmlType="button" onClick={() => setShowItemMasterData(true)}>
                  Hàng Hóa
                </Button>
              </div>
              <div>
                <Button type="primary" htmlType="submit">
                  Search
                </Button>
                <Button
                  type="default"
                  className='custom-default-btn'
                  onClick={() => {
                    form.resetFields();
                  }}
                >
                  Clear
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Form>
      <ItemMasterData />
    </>

  );
};

// const App: React.FC = () => (
//   <div>
//     <AdvancedSearchForm />
//     <div className="search-result-list">Search Result List</div>
//   </div>
// );

export default SalesQuotation;